export interface IAvailableServiceColors {
  map: (callback: (color: string, index: number) => any) => any[];
  [index: number]: string;
}

export const availableServiceColors: IAvailableServiceColors = {
  map: (callback) => {
    return [
      '#82a774',
      '#b22e53',
      '#ebb65d',
      '#95c5a6',
      '#b26492',
      '#cc9e52',
      '#8ebec3',
      '#a476ca',
      '#e5774c',
      '#385f87',
      '#5d5a79',
      '#c46f4e',
      '#7684ca',
      '#8b8b8b',
      '#7b6161',
      '#e5e6e7',
      '#ffffff',
    ].map(callback);
  },
  0: '#82a774',
  1: '#b22e53',
  2: '#ebb65d',
  3: '#95c5a6',
  4: '#b26492',
  5: '#cc9e52',
  6: '#8ebec3',
  7: '#a476ca',
  8: '#e5774c',
  9: '#385f87',
  10: '#5d5a79',
  11: '#c46f4e',
  12: '#7684ca',
  13: '#8b8b8b',
  14: '#7b6161',
  15: '#e5e6e7',
  16: '#ffffff',
};

export const defaultTagHexcolor: string = '#385f87';
